// Searchable article select — wraps a native <select> with tom-select.
// Fires "article-select:change" on the element when value changes so
// inventory_form_controller can react (e.g. auto-fill name field).
import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.default.css"

export default class extends Controller {
  connect() {
    this.ts = new TomSelect(this.element, {
      create: false,
      allowEmptyOption: true,
      maxOptions: 300,
      searchField: ["text"],
      onChange: (value) => {
        // Retrieve the text from the rendered item (strip leading/trailing whitespace)
        const selectedText = value
          ? (this.ts.getOption(value)?.textContent?.trim() ?? "")
          : ""

        this.element.dispatchEvent(new CustomEvent("article-select:change", {
          bubbles: true,
          detail: { value, text: selectedText }
        }))
      }
    })

    // Tag the wrapper so our tavern CSS overrides scope correctly
    this.ts.wrapper.classList.add("ts-tavern")
  }

  disconnect() {
    this.ts?.destroy()
  }
}
